// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".light-mode .background-color .o-side__content{background-color:#fff}.dark-mode .background-color .o-side__content{background-color:#191718}.light-mode .background-color .o-side__overlay{background-color:#fff;opacity:.86}.dark-mode .background-color .o-side__overlay{background-color:#191718;opacity:.86}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
